var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "base-page-v2",
      class: {
        "no-head": _vm.routex.hideHeader,
        "base-page-v2-children": _vm.showChildren
      }
    },
    [
      _c("navigator", {
        staticClass: "page-header",
        class: _vm.routex.hideHeader,
        on: { "change-show-children": _vm.changeShowChildren }
      }),
      _vm._v(" "),
      !_vm.routex.keepAlive
        ? _c("router-view", { staticClass: "page-container" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.routex.keepAlive
            ? _c("router-view", { staticClass: "page-container keep-alive" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("footer-bar")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-011b6644", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011b6644","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/v2/views/components/BasePage.vue
// module id = null
// module chunks = 